var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 450 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 300,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 150,
    fill: "#ce1126"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f9d616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.115,91.82A58.5,58.5 0 1,1 187.916,195.244L179.358,205.685A72,72 0 1,0 232.526,78.394z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "s3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M302.62435,142.35494C303.12516,147.43953 303.12516,152.56101 302.62435,157.6456L287.69659,156.17534C288.10106,152.06855 288.10106,147.93196 287.69659,143.82518z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(22.5,225,150)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(45,225,150)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    transform: "rotate(-67.5,225,150)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    transform: "rotate(67.5,225,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.32444,114.65618H250.67551L209.1325,144.84033 224.99998,96.000328 240.86746,144.84033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87869,216.3146C291.71694,220.02891 296.88529,223.69038 300.6338,227.01716C304.38231,230.34392 307.25434,233.10958 309.57908,236.88884C312.98624,242.42773 309.16023,248.7008 303.85486,245.01872C300.98581,243.02751 299.18307,237.65214 294.78788,233.20395C291.53252,230.43267 288.96764,227.52745 280.78551,226.1257C280.39268,226.05841 280.27777,225.22842 280.58665,224.86618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M231.36058,197.84505 251.60791,209.8174 256.00949,226.89558 279.24991,225.13494 289.46162,213.16262 251.60791,186.9291 231.36058,197.84505z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66324,223.6894C253.62799,206.37539 237.07238,197.02622 212.12131,182.83938C202.31974,177.26634 187.0985,163.25747 199.1052,139.81914C199.86106,155.20638 260.67394,197.4423 286.3703,215.80679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M216.08561,167.51949C236.13137,186.41034 261.37565,201.82127 283.89761,218.85496"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 290.4,
    cy: 222.297,
    r: 1.008,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 7.41957,
    y: 6.4655991
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 13.93812,
    y: 13.090317
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/ao.a76f7aa81ee54cd385a626fda5eb0de7.svg";
export { ForwardRef as ReactComponent };